import styled from 'styled-components';
import { devices } from '../../../globalStyle' 

export const TabIcon = styled.span`
  margin-right: 6px;
  vertical-align: middle;
  display: inline-flex;
`;


export const Content = styled.div`
  width: 100%;
  margin-top: 1rem;
  overflow-y: auto;
  font-family: 'Inter', sans-serif;
  min-height: 80%;
  max-height: 80%;

  /* Estilos do scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`;

export const CopyableDescription = styled.span`
  cursor: pointer;
`;

export const RefreshNoBorder = styled.button`
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`;